import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"

export const resetAuthoringDraft = api(async function resetAuthoringDraft({ projectId, scheduleId }) {
    return mutate(
        gql`
            mutation ResetAuthoringDraft($projectId: String!, $scheduleId: String!) {
                resetAuthoringDraft(projectId: $projectId, scheduleId: $scheduleId)
            }
        `,
        { projectId, scheduleId },
        { returns: "resetAuthoringDraft" }
    )
})
